angular
	.module('mobileReservation')
	.controller('trMainCtrl', function (
		$scope,
		$location,
		$pusher,
		dataFactory,
		tgConfig,
		$q,
		$interval,
		tgClock,
		$window,
		$timeout,
		tgMenu,
		tgTranslate
	) {
		var cachedAlertMsg = null //So the last received message is not lost when the init() function gets called by the focus event
		var venueTimezone = 'America/Sao_Paulo' //For now, same for every venue
		$scope.showMosaic = false
		$scope.defaultPreOrderMenuTitleHtml =
			'<strong>Adicione</strong> alguns itens e deixe seu <strong>momento inesquecível!</strong>'

		var chosenLanguageByUser
		setLanguage('pt')

		function setLanguage(lang) {
			if (!lang || lang.length == 0) lang = 'pt'
			lang = lang.toLowerCase()

			$scope.language = lang
			$scope.bandLanguage = lang + '.jpg'
			$scope.languageIni = $scope.language.toUpperCase()

			tgTranslate.use(lang)
		}

		$scope.changeLanguage = function (lang) {
			setLanguage(lang)
			chosenLanguageByUser = lang
			init()
		}

		$scope.getPreOrderMenuStyleAdjustments = function () {
			if ($scope.app.preOrderMenu) {
				return {
					top: '-50px',
					position: 'relative',
				}
			} else {
				return null
			}
		}

		function isInsideReservationThreshold(reservation, hoursThreshold) {
			var reservationTimestamp = moment.tz(
				moment.utc(reservation.reservationDay).format('YYYY-MM-DD') + ' ' + reservation.reservationTime,
				venueTimezone
			)
			var diff = reservationTimestamp.diff($scope.clock.now, 'hours')
			return diff < hoursThreshold
		}

		$scope.customerCanConfirmReservation = function () {
			if ($scope.reservation.status != 'New' && $scope.reservation.status != 'Overbook') {
				return false
			}

			if (!$scope.reservation.confirmationPeriodStart) {
				//Old reservations without this field
				return isInsideReservationThreshold($scope.reservation, 24)
			} else {
				// return $scope.clock.now.isAfter($scope.reservation.confirmationPeriodStart, 'minute');
				return true
			}
		}

		$scope.customerCanCancelReservation = function () {
			if (
				$scope.reservation.status != 'New' &&
				$scope.reservation.status != 'Confirmed' &&
				$scope.reservation.status != 'Overbook'
			) {
				return false
			}

			if (!$scope.reservation.confirmationPeriodStart) {
				//Old reservations without this field
				return isInsideReservationThreshold($scope.reservation, 24)
			} else {
				// return $scope.clock.now.isAfter($scope.reservation.confirmationPeriodStart, 'minute');
				return true
			}
		}

		$scope.savePreOrderedItems = function () {
			$scope.loader = true

			var preOrderedItems = []
			_.map($scope.preOrderMenu.menuItems, function (preOrderItem) {
				if (preOrderItem.selected) {
					preOrderedItems.push(preOrderItem._id)
				}
			})

			dataFactory
				.setReservation($scope.reservation._id, preOrderedItems, $scope.reservation.customer)
				.then(function (data) {
					$scope.savedPreOrderedItems = true
					$timeout(function () {
						$scope.savedPreOrderedItems = false
					}, 7000)
					// console.log('data', JSON.stringify(data, null, 4));
				})
				.catch(function (err) {
					//TODO: show user
					console.log('Erro ao tentar atualizar reserva:', err)
				})
				.finally(function () {
					$scope.loader = false
				})
		}

		$scope.showMenu = function (menuId, label, order) {
			$scope.loader = true

			tgMenu
				.getMenuWithItems(menuId, $scope.language)
				.then(function (response) {
					bindMenuData(label, response.data, order)
					$scope.openPath('/mobileReservation/menu/' + menuId + '/', $scope.reservationId)
				})
				.catch(function (err) {
					//TODO
				})
				.finally(function () {
					$scope.loader = false
				})
		}

		$scope.openPath = function (_path, _id) {
			if (_id) {
				var page = _path + _id
			} else {
				var page = _path
			}
			$location.path(page)
		}

		function getImagePath(image, itemType, disabledThumb) {
			return tgMenu.getImagePath(image, itemType, disabledThumb)
		}
		$scope.getImagePath = getImagePath

		$scope.confirmReservation = function () {
			$scope.loader = true
			dataFactory
				.confirmReservation($scope.reservation.venue, $scope.reservation._id, $scope.reservation.customer)
				.then(function (data) {
					//void
				})
				.catch(function (err) {
					//TODO: show user
					console.log('Erro ao tentar confirmar a reserva:', err)
				})
				.finally(function () {
					$scope.loader = false
				})
		}

		$scope.cancelReservation = function () {
			$scope.loader = true
			dataFactory
				.cancelReservation($scope.reservation.venue, $scope.reservation, $scope.reservation.customer)
				.then(function (data) {
					//void
				})
				.catch(function (err) {
					//TODO: show user
					console.log('Erro ao tentar cancelar reserva:', err)
				})
				.finally(function () {
					$scope.loader = false
				})
		}

		$scope.goToMosaic = function () {
			return $scope.openPath('/mobileReservation/', $scope.reservationId)
		}

		$scope.setSelectedItem = function (item) {
			$scope.selectedItem = null
			$scope.selectedItem = item
		}

		$scope.getVarietalsList = function (item) {
			return tgMenu.getVarietalsList(item, $scope.language)
		}

		$scope.getWineTypeStyle = function (wineTypeSlug) {
			return { color: tgMenu.getWineTypeColor(wineTypeSlug) }
		}

		$scope.getBeerTypeStyle = function (color) {
			return { color: color }
		}

		function bindMenuData(label, menu, order) {
			$scope.selectedMenu = {}
			$scope.selectedMenu.label = label
			$scope.selectedMenu.order = order
			$scope.selectedMenu.currency = menu.currency
			// console.log('menu.menuItems', JSON.stringify(menu.menuItems, null, 4));
			$scope.selectedMenu.items = menu.menuItems
		}

		function bindSelectedItems(menuItems, selectedMenuItems) {
			_.map(menuItems, function (menuItem) {
				var found = _.find(selectedMenuItems, function (selected) {
					return selected == menuItem._id
				})
				if (found) {
					menuItem.selected = true
				}
			})
		}

		function init() {
			$scope.loader = true
			$scope.app = {}
			$scope.reservation = {}
			$scope.clock = tgClock.getClock()
			$scope.selectedItem = null

			var urlParts = $location.path().split('/')
			$scope.reservationId = urlParts[urlParts.length - 1]

			var selectedMenuId = null
			if (urlParts.indexOf('menu') > -1) selectedMenuId = urlParts[urlParts.length - 2]

			var appAndReservationPromises = {
				getApp: dataFactory.getApp($scope.reservationId),
				getReservation: dataFactory.getReservation($scope.reservationId),
			}

			$q.all(appAndReservationPromises)
				.then(function (resolved) {
					if (!resolved.getApp.data || !resolved.getReservation.data) {
						$scope.loader = false
						return $location.path('notfound')
					}

					$scope.app = resolved.getApp.data

					_.map($scope.app.siteCovers, function (siteCover) {
						if (siteCover.order == 1) {
							$scope.app.siteCover = siteCover.coverUrl
						}
					})
					$scope.showMosaic = $scope.app.mosaicButtons && $scope.app.mosaicButtons.length > 0

					$scope.reservation = resolved.getReservation.data
					if (!chosenLanguageByUser || chosenLanguageByUser.length == 0) setLanguage($scope.reservation.lang)

					$scope.originBradesco = $scope.reservation.origin.label == 'Bradesco' ? true : false

					if (cachedAlertMsg) {
						$scope.reservation.alertMsg = cachedAlertMsg
					}

					var client = new Pusher(tgConfig.pusherWaitlistKey)
					var pusher = $pusher(client)

					var venueChannel = pusher.subscribe($scope.app.venue._id)

					venueChannel.bind('reservation:update', function (reservation) {
						if (reservation._id == $scope.reservation._id) {
							$scope.reservation.reservationTime = reservation.reservationTime
							$scope.reservation.reservationDay = reservation.reservationDay
							$scope.reservation.partySize = reservation.partySize
							$scope.reservation.status = reservation.status
						}
					})

					venueChannel.bind('reservation:seat', function (reservation) {
						if (reservation._id == $scope.reservation._id) {
							$scope.reservation.status = reservation.status
							var alertMsg =
								'Sua mesa está pronta. Identifique-se com nosso atendimento. Obrigado pela sua preferência.'
							$scope.reservation.alertMsg = alertMsg
							cachedAlertMsg = alertMsg
						}
					})

					venueChannel.bind('reservation:cancel', function (reservation) {
						if (reservation._id == $scope.reservation._id) {
							$scope.reservation.status = reservation.status
						}
					})

					venueChannel.bind('reservation:notify', function (reservation) {
						if (reservation._id == $scope.reservation._id) {
							$scope.reservation.status = reservation.status
							$scope.reservation.alertMsg = reservation.msg
							cachedAlertMsg = reservation.msg
						}
					})

					var menusPromises = {}

					if (selectedMenuId)
						menusPromises.selectedMenu = tgMenu.getMenuWithItems(selectedMenuId, $scope.language)

					if ($scope.app.preOrderMenu)
						menusPromises.preOrderMenu = tgMenu.getMenuWithItems($scope.app.preOrderMenu, $scope.language)

					return $q.all(menusPromises)
				})
				.then(function (resolved) {
					if (selectedMenuId) {
						for (var i = 0; i < $scope.app.mosaicButtons.length; i++) {
							var button = $scope.app.mosaicButtons[i]
							if (button.pointer && button.pointer.objectId == selectedMenuId) {
								bindMenuData(button.name[$scope.language], resolved.selectedMenu.data, button.order)
								break
							}
						}
					}

					if ($scope.app.preOrderMenu) {
						$scope.preOrderMenu = resolved.preOrderMenu.data
						bindSelectedItems($scope.preOrderMenu.menuItems, $scope.reservation.preOrderedItems)
					}
				})
				.catch(function (err) {
					//TODO: show user
					console.log('Erro ao tentar carregar as informações:', err)
				})
				.finally(function () {
					$scope.loader = false
				})
		}

		// var winFocus = angular.element($window).on('focus', init);
		// $scope.$on('$destroy', function () {
		// 	winFocus.off('focus', init);
		// });

		init()

		$scope.getBackgroundImageStyle = function () {
			if ($scope.app && $scope.app.siteCover)
				return { 'background-image': 'url(' + getImagePath($scope.app.siteCover) + ')' }

			return {}
		}
	})
